import PropTypes from "prop-types";
import classNames from "classnames";
import I18n from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";

export const StatusBadge = ({ visibility }) => {
  const isDraft = visibility === "draft";
  return (
    <div
      className={classNames(
        "mr-1 flex items-center space-x-0.5 rounded px-2 py-1",
        isDraft ? "bg-secondary text-dark" : "bg-green-100",
      )}
    >
      <Typography.LabelXs color={isDraft ? "text-dark" : "text-green-900"}>
        {I18n.t("courses.admin_summary.status")}
      </Typography.LabelXs>
      <Typography.LabelXs
        color={isDraft ? "text-dark" : "text-green-900"}
        weight="semibold"
      >
        {I18n.t(`spaces.form.create.visibility_types.${visibility}`)}
      </Typography.LabelXs>
    </div>
  );
};

StatusBadge.propTypes = {
  visibility: PropTypes.string,
};
